import React from 'react';
import { observer } from 'mobx-react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import Layout from './Layout';
import WorldPage from '../pages/world';
import ManagePage from '../pages/manage';
import useEnvironment from '../store/models/env/useEnvironment';
import useProfile from '../store/models/profile/useProfile';
import useSession from '../store/models/env/useSession';

function PrivateRoute({ element }) {
    const { isLoggedIn, initialized } = useSession();
    if (!initialized) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
                <CircularProgress size={32} sx={{ color: 'var(--ecal-lightblue)' }} />
            </Box>
        );
    }
    if (!isLoggedIn) return <Navigate to="/" replace />;
    return element;
}

function AppRoutes() {
    useEnvironment();
    useProfile();

    return (
        <Routes>
            <Route element={<Layout />}>
                <Route path="/" element={<WorldPage />} />
                <Route path="/world" element={<WorldPage />} />
                <Route path="/manage" element={<PrivateRoute element={<ManagePage />} />} />
                <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
        </Routes>
    );
}

export default observer(AppRoutes);
